import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { InteractionType } from '@azure/msal-browser';

import { msalInstanceFactory, msalGuardConfigFactory, protectedResources } from './core/services/msal-config';
import { AuthInterceptor } from '../app/core/interceptors/auth.interceptor';
import { AuthGuard } from './core/guards/auth.guard';
import { AdminGuard } from './core/guards/admin.guard';

@NgModule({
  declarations: [
    // other components (AppComponent is now standalone and bootstrapped separately)
  ],
  imports: [
    BrowserModule,
    CommonModule,
    // Register MSAL providers (MsalService, MsalBroadcastService, etc.) by calling forRoot
    MsalModule.forRoot(
      // msal instance
      msalInstanceFactory(),
      // guard config
      msalGuardConfigFactory(),
      // interceptor config
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map<string, Array<string>>([
          [protectedResources.functionApi.endpoint, protectedResources.functionApi.scopes]
        ])
      }
        ),
        RouterModule.forRoot([
      {
        path: '',
        redirectTo: '/create-billing',
        pathMatch: 'full'
      },
      {
        path: 'report',
        loadComponent: () => import('./features/report/report.component').then(m => m.ReportComponent),
        canActivate: [AuthGuard, AdminGuard]
      },
      { path: 'my-billing', loadChildren: () => import('./features/my-billing/my-billing.module').then(m => m.MyBillingModule) },
      { path: 'create-billing', loadChildren: () => import('./features/create-billing/create-billing.module').then(m => m.CreateBillingModule) },
      {
        path: 'help',
        loadComponent: () => import('./features/help/help.component').then(m => m.HelpComponent)
      },
        ])
      ],
      providers: [
    // MsalModule.forRoot already provides MSAL_INSTANCE, MSAL_GUARD_CONFIG and MsalService,
    // so only register the app's HTTP interceptor here.
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: []
})
export class AppModule { }